import { isDevTeamUser } from "@tradingApp/helpers/users/devTeam";
import { isDropstabTeamUser } from "@tradingApp/helpers/users/dropstabTeam";
import { isPmUser } from "@tradingApp/helpers/users/isPm";
import type { I18N_LOCALES } from "@tradingApp/Providers/I18nProvider/constants";

const {
  PROD,
  VITE_DPS_API_BASE_URL,
  VITE_DPS_SERVICE_API_BASE_URL,
  VITE_HYPER_PARSER_API_BASE_URL,
  VITE_HYPERLIQUID_WEBSOCKET_FALLBACK_URL,
  VITE_HYPERLIQUID_WEBSOCKET_URL,
  VITE_HYPERUNIT_API_BASE_URL,
  VITE_ONRAMPER_API_KEY,
  VITE_ONRAMPER_URL,
  VITE_PUBLIC_API_BASE_URL,
  VITE_STATIC_DROPSTAB_BASE_URL,
  VITE_SWS_API_BASE_URL,
  VITE_TG_ANALYTICS_APP_NAME,
  VITE_TG_ANALYTICS_TOKEN,
  VITE_TRADING_BUILDER_ADDRESS,
  VITE_WS_API_BASE_URL,
  VITE_TELEGRAM_PROXY_BASE_URL,
  VITE_PNL_SHARE_BASE_URL,
} = import.meta.env;

export const DPS_API_BASE_URL = VITE_DPS_API_BASE_URL;

export const DPS_SERVICE_API_BASE_URL = VITE_DPS_SERVICE_API_BASE_URL;

export const HYPER_PARSER_API_BASE_URL = VITE_HYPER_PARSER_API_BASE_URL;

export const HYPERLIQUID_WEBSOCKET_URL = VITE_HYPERLIQUID_WEBSOCKET_URL;

export const HYPERLIQUID_FALLBACK_WEBSOCKET_URL =
  VITE_HYPERLIQUID_WEBSOCKET_FALLBACK_URL;

export const HYPERUNIT_API_BASE_URL = VITE_HYPERUNIT_API_BASE_URL;

export const IS_PRODUCTION = PROD;

export const PUBLIC_API_BASE_URL = VITE_PUBLIC_API_BASE_URL;

export const SWS_API_BASE_URL = VITE_SWS_API_BASE_URL;

export const TG_ANALYTICS_APP_NAME = VITE_TG_ANALYTICS_APP_NAME;

export const TG_ANALYTICS_TOKEN = VITE_TG_ANALYTICS_TOKEN;

export const TRADING_BUILDER_ADDRESS = VITE_TRADING_BUILDER_ADDRESS;

export const WS_API_BASE_URL = VITE_WS_API_BASE_URL;

export const TELEGRAM_PROXY_BASE_URL = VITE_TELEGRAM_PROXY_BASE_URL;

export const PNL_SHARE_BASE_URL = VITE_PNL_SHARE_BASE_URL;

export const ONRAMPER_URL = VITE_ONRAMPER_URL;

export const ONRAMPER_API_KEY = VITE_ONRAMPER_API_KEY;

export const MINUTE_IN_MS = 1000 * 60;

export const HOUR_IN_MS = MINUTE_IN_MS * 60;

export const DAY_IN_MS = HOUR_IN_MS * 24;

export const MONTH_IN_MS = DAY_IN_MS * 30;

export const WEEK_IN_MS = DAY_IN_MS * 7;

export const STATIC_DROPSTAB_BASE_URL = VITE_STATIC_DROPSTAB_BASE_URL;

export const INVITE_SHARE_URL =
  "https://t.me/inferno_trading_bot/?startapp=ref_";

export const PORTAL_IDS = {
  BODY: "portal-body",
  LAYOUT_WITH_NAVIGATION: "portal-layout-navigation",
} as const;

export const TRADING_REFERRER_CODE = "FOMOAPP";

export const SUPPORT_CHAT: Record<(typeof I18N_LOCALES)[number], string> = {
  en: "https://t.me/dropstab_EN",
  ru: "https://t.me/dropstab_com",
};

export const USER_WALLET_ERROR_MESSAGE_REGEX =
  /User or API Wallet 0x[a-fA-F0-9]{40} does not exist/;

export const CLARITY_ID = import.meta.env.VITE_CLARITY_ID;

export const DEV_TEAM_USER_WHITE_LIST = [
  "Danil_Fefelov",
  "dfomo_test1",
  "dfomo_test2",
  "dfomo_test3",
  "dmitrii_panov",
  "dodgezy", // Daniel
  "dropsgemini",
  "dropsgpt",
  "rekogz",
  "roman_dropstab",
  "roman_sokhin",
];

export const DROPSTAB_TEAM_USER_WHITE_LIST = [
  "a1mighty",
  "Kwlad1ck",
  "Alex_Kel",
  "aydar_farrakhov",
  "carnosauria",
  "kbsQA7",
  "ladazidane",
  "MisterDeFi",
  "nikitins19",
  "targs081",
  "testbotdrops",
  "userflame",
];

export const IS_DEV_TEAM_USER = isDevTeamUser();

export const IS_DROPSTAB_TEAM_USER = isDropstabTeamUser() || IS_DEV_TEAM_USER;

export const IS_PM_USER = isPmUser();

export const TEST_WALLET_ADDRESS = "0x596d22551154348454028f01f1b3f5525944d143";
